import script from "./Our_viruchka_2.vue?vue&type=script&setup=true&lang=js"
export * from "./Our_viruchka_2.vue?vue&type=script&setup=true&lang=js"

import "./Our_viruchka_2.vue?vue&type=style&index=0&id=da98a1ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da98a1ec"]])

export default __exports__